const _ = require("lodash");
const React = require("react");
const PT = require("prop-types");
const createReactClass = require("create-react-class");

const SequenceRow = require("./SequenceRow");

const styles = require("./styles/AssignmentsList.css");

module.exports = createReactClass({
	displayName: "AssignmentsList",

	propTypes: {
		user: PT.object.isRequired,
		page: PT.object.isRequired,
		title: PT.string,
		blocks: PT.array,
		clickHandler: PT.func,
	},

	clickHandler: function() {
		const {clickHandler} = this.props;
		clickHandler && clickHandler();
	},

	render: function() {
		const {blocks, title, page, user} = this.props;

		const titleRow = title ? <p className={styles.title}>{title}</p> : null;
		const assignments = blocks.map(block => {
			const blockType =
				block.blockType === "test" ? block.blockType : "trainer";
			return (
				<SequenceRow
					key={`assignmentsList_${block.blockID}`}
					user={user}
					type={"assignment"}
					// note that we can just assume that assigned blocks are unlocked
					blockModel={_.extend({}, block, {blockType, unlocked: true})}
					clickHandler={this.clickHandler}
					page={page}
				/>
			);
		});

		return (
			<div>
				{titleRow}
				<div className={styles.list}>{assignments}</div>
			</div>
		);
	},
});
